export function closure<T>(context: T, func: (context: T) => any) {
	return function ClosureFunction(): any {
		return func(context);
	};
}
